import styled from 'styled-components';
import { COLORS } from '@/styles/colorTheme';
import { media } from '@/media';

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;

  padding-bottom: 4px;
  border-bottom: 1px solid ${COLORS.Background100};
  cursor: pointer;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 4px 4px 4px 8px;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;

  :hover {
    background-color: ${COLORS.Background50};
  }
`;

export const NameWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  margin-right: 20px;

  grow: 1;

  ${media.mobile`
    width: 100px;
`}
`;

export const RankContainer = styled.div`
  width: 26px;
  display: flex;
  justify-content: center;
  shrink: 0;
`;

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  grow: 1;
`;

export const DataWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Data = styled.div`
  padding: 4px;
  display: flex;
  gap: 4px;
`;

export const Img = styled.img``;
